import React, { useRef, useState } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import { IconChevronLeft } from '@tabler/icons-react';

export default function Faq() {

    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef([]);

    const toggleCollapse = (id) => {
        setIsOpen((isOpen === id ? null : id));
    };

    const faqItem = [
        {
            title: 'General',
            background: 'sky',
            children: [
                {
                    id: 1,
                    question: "How may times Lorum Ipsum has been used in this theme?",
                    answer: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.",
                },
                {
                    id: 2,
                    question: "How many instances of Lorum Ipsum usage can be found on the web?",
                    answer: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.",
                },
                {
                    id: 3,
                    question: "How much does it cost to use Lorem ipsum?",
                    answer: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.",
                },
            ],
        },
        {
            title: 'Security and Privacy',
            background: 'yellow',
            children: [
                {
                    id: 4,
                    question: "How much does it cost to use Lorem ipsum?",
                    answer: "non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.",
                },
                {
                    id: 5,
                    question: "Lorem ipsum commodo adipisicing sunt ad aliqua velit nulla?",
                    answer: "enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.",
                },
                {
                    id: 6,
                    question: "How much does it cost to use Lorem ipsum?",
                    answer: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.",
                },
            ],
        },
    ]

    return (
        <>
            <Breadcrumb title="FAQs" path="Pages / FAQs" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                {faqItem.map((item, key) => (
                    <div key={key} className='mb-30'>
                        <p className={`md:p-10 py-5 px-10 bg-${item.background} text-white font-medium uppercase tracking-[1px]`}>
                            {item.title}
                        </p>
                        <div>
                            {item.children.map((res, key) => (
                                <div key={key} className='p-15 border-b border-border'>
                                    <div onClick={() => toggleCollapse(res.id)} className='w-full flex items-center justify-between gap-5 text-[16px]/[24px] font-medium'>
                                        {res.question}
                                        <span className={`transition-all duration-300 ease-in-out ${isOpen === res.id ? 'rotate-90' : '-rotate-90'}`}>
                                            <IconChevronLeft className='stroke-[1] text-text-secondary' />
                                        </span>
                                    </div>
                                    <div
                                        ref={ref => contentRef.current[res.id - 1] = ref}
                                        className="overflow-hidden transition-all duration-300"
                                        style={{ height: (isOpen === res.id) ? `${contentRef.current[res.id - 1]?.scrollHeight}px` : '0' }}
                                    >
                                        <p className='mt-15 text-[16px]/[24px]'>
                                            {res.answer}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}
